import Model from "./base/model";

class SimulationQuoteTransporterAddress extends Model {
  resourceName() {
    return "simulation_quotes_transporters_addresses";
  }

  fields() {
    return {
      simulation_quote_transporter_id: "",
      address_id: "",
      type: "",
      address: ""
    };
  }

}

export default new SimulationQuoteTransporterAddress();
